

//Customer selector 
export const selectCustomersList = (state) => state.salesPharma?.customersList;
export const selectCustomersLoading = (state) => state.salesPharma.loading;
export const selectError = (state) => state.salesPharma.error;




// Sales Selector
export const selectSalesVoucherNumber = (state) => state.salesPharma.salesVoucherNumber;


export const selectDefaultAccount = (state)=> state.salesPharma.defaultAccount